import React from "react"
import { navigate } from "gatsby"
import { injectIntl } from "react-intl"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import { makeStyles } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  langSelector: props => ({
    fontSize: props.fontSize,
    marginRight: props.marginRight,
    fontFamily: theme.typography.button.fontFamily,
    float: "right",
    position: "relative",
    bottom: theme.spacing(0.125),
  }),
  menuItems: {
    fontFamily: theme.typography.button.fontFamily,
  },
  select: {
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1),
  },
  root: {
    "&:focus": { backgroundColor: "transparent" },
  },
  "@global": {
    ".MuiList-padding": {
      paddingTop: "0",
      paddingBottom: "0",
    },
    ".MuiMenuItem-gutters": {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    ".MuiPaper-root": {
      marginLeft: "-9px",
      '& li[aria-disabled="false"] > span': {
        color: theme.palette.black.main
      }
    }
  },
  mobileIcon: {
    fill: theme.palette.white.main
  },
  colorSwitcher: {
    color: props => props.isSplash ? theme.palette.white.main : theme.palette.black.main
  },
}))
const localeConsts = require("../../constants/localeConsts")
let url
export default injectIntl(props => {
  const properties = {
    fontSize: props.fontSize,
    mobile: props.mobile,
    marginRight: props.marginRight,
    isSplash: props.isSplash,
  }
  const classes = useStyles(properties)
  const lang = props.intl.locale
  const handleLangChange = event => {
    let slug = props.slug;

    if (event.target.value === localeConsts.en && slug.endsWith(localeConsts.esPath)) {
      slug = slug.replace(localeConsts.esPath, localeConsts.enPath);
    } else if (event.target.value === localeConsts.es && slug.endsWith(localeConsts.enPath)) {
      slug = slug.replace(localeConsts.enPath, localeConsts.esPath);
    }

    if (props.response) {
      url = "/" + event.target.value + slug + props.response
    } else {
      url = "/" + event.target.value + slug
    }
    navigate(url)
  }
  return (
    <Select
      value={lang}
      className={props.className ? props.className : classes.langSelector }
      IconComponent={ExpandMoreIcon}
      onChange={ handleLangChange }
      disableUnderline
      MenuProps={{
        style: {zIndex: 1301}
      }}
      classes={{
        select: props.select ? props.select : classes.select,
        icon: props.mobile ? classes.mobileIcon : classes.icon,
        root: classes.root,
      }}
    >
      <MenuItem className={classes.menuItems} value={localeConsts.en}>
        <Typography className={classes.colorSwitcher} variant={"button"} data-cy="english-option">EN</Typography>
      </MenuItem>
      <MenuItem value={localeConsts.es}>
        <Typography className={classes.colorSwitcher} variant={"button"} data-cy="spanish-option">ES</Typography>
      </MenuItem>
    </Select>
  )
})
